// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"250f4ff9","74":"82d7d6c1","339":"94654111","551":"6dbf4956","629":"75d997ca","631":"57881adf","640":"1b2aeced"}[chunkId] + ".chunk.js";
};